// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2UEcr","right":"styles_right__1haQ_"};